import { styled } from '@mui/material/styles';
import { BigidBody1, BigidRadio } from '@bigid-ui/components';

export const StyledContentCard = styled('div')<{ selected: boolean }>(({ theme, selected }) => ({
  padding: 16,
  borderRadius: 8,
  border: selected ? `1px solid ${theme.palette.bigid?.primary700}` : theme.vars.tokens?.bigid?.borderDefault,
  boxShadow: theme.vars.tokens?.bigid?.shadow5,
  backgroundColor: theme.vars.palette.bigid?.gray100,
  cursor: 'pointer',
  width: '100%',

  '&:hover': {
    border: `1px solid ${theme.palette.bigid?.primary700}`,
  },

  [theme.breakpoints.up('sm')]: {
    width: 190,
    minHeight: 200,
    '&:hover, &:focus-within': {
      '& .item-description': {
        display: 'block',
      },
      '& .item-primary-info': {
        display: 'none',
      },
    },
  },
}));

export const StyledRadioButton = styled(BigidRadio)({
  margin: 0,
  marginTop: '-6px',
  marginRight: '-6px',
});

export const StyledContentBox = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  [theme.breakpoints.down('sm')]: {
    marginTop: -26,
    marginBottom: 16,
    display: 'block',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export const StyledTitle = styled(BigidBody1)(({ theme }) => ({
  fontWeight: 700,

  [theme.breakpoints.up('sm')]: {
    fontWeight: 400,
    textAlign: 'center',
    marginTop: 16,
    maxHeight: 48,
    overflow: 'hidden',
  },
}));

export const StyledDescription = styled(BigidBody1)(({ theme }) => ({
  display: 'none',
  maxHeight: 140,
  overflow: 'auto',

  [theme.breakpoints.down('sm')]: {
    marginTop: 16,
    maxHeight: 'auto',
  },
}));
